
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proyectos-especiales",
      function () {
        return require("private-next-pages/proyectos-especiales/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proyectos-especiales"])
      });
    }
  